/**
 * Helper function to find a hero build by id.
 */
export function findHeroBuildById(heroBuilds, buildId) {
  if (!heroBuilds) {
    return undefined;
  }

  return heroBuilds.find((build) => {
    return build.hero_build_id === buildId;
  });
}
